class ProductRecommendationsCustom extends HTMLElement {
  constructor() {
    super();
  }

  async connectedCallback() {
    const productId = this.getAttribute('product-id');
    const limit = this.getAttribute('limit') || 4;
    const currency = this.getAttribute('currency') || 'USD';
    const endpoint = `/recommendations/products.json?product_id=${productId}&limit=${limit}`;
    const formatPrice = (cents, currency) => {
      const price = cents / 100;
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: currency,
        minimumFractionDigits: 2
      }).format(price);
    };

    if(this.classList.contains("have-meta")) {
      $('product-recommendations-custom .recommendations-grid').slick({
        dots: false,
        arrows: true,
        infinite: false,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
      });
    } else {
      try {
        const res = await fetch(endpoint);
        const data = await res.json();
        if (!data.products || data.products.length === 0) {
          return;
        }
        const productsHtml = data.products.map(product => {
          // todas las variantes
          const variantOptions = product.variants.filter(variant => variant.available).map(variant => `<option value="${variant.id}">${variant.title}</option>`).join('');
          console.log(product);
          return `
            <div class="card-recomendation-custom">
              <div class="wrapp">
                <a class="logo_card-recomendation" href="${product.url}">
                  <img src="${product.featured_image}" alt="${product.title}" loading="lazy">
                </a>
                <div class="content">
                  <h4>${product.title}</h4>
                  <p>${formatPrice(product.price, currency)}</p>
                  <div class="btns_wrapp">
                    <div class="select_wrapp">
                      <p>Size: </p>
                      <select class="select-drawer_${product.id}">
                        ${variantOptions}
                      </select>
                    </div>
                    <button onclick="addToCartCustom(${product.id})" class="button">Add</button>
                  </div>
                </div>
              </div>
            </div>
          `;
        }).join('');
        this.innerHTML = `
          <div class="recommendations-grid">
            ${productsHtml}
          </div>
        `;
        $('product-recommendations-custom .recommendations-grid').slick({
          dots: false,
          arrows: true,
          infinite: false,
          speed: 300,
          slidesToShow: 1,
          slidesToScroll: 1,
        });
      } catch (error) {
        console.error('Error al cargar recomendaciones:', error);
      }
    }
  }
}

customElements.define('product-recommendations-custom', ProductRecommendationsCustom);

function addToCartCustom(productID) {
  let select_item = document.querySelector(`.card-recomendation-custom .select-drawer_${productID}`);
  if (select_item) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        id: select_item.value,
        quantity: 1
      })
    })
    .then(res => {
      if (!res.ok) throw new Error("No se pudo agregar al carrito.");
      return res.json();
    })
    .then(data => {
      fetch('/cart.js')
      .then(res => res.json())
      .then(cartData => {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'custom',
          cartData: cartData
        });
      });
    })
    .catch(err => {
      console.error("Error al agregar al carrito:", err);
    }); 
  }
}

// configuracion de los filtros, para abrir hover
document.addEventListener('DOMContentLoaded', () => {
  
  const getCountry2 = async () => {
    try {
      const response = await fetch('https://api.country.is/');
      const data = await response.json();
      return data.country;
    } catch (error) {
      console.error('Error obteniendo el país:', error);
    }
  }

  getCountry2().then(countryAPI => {
    if (countryAPI) {
      console.log("countryAPI");
      console.log(countryAPI);
      countryIpUpdate(countryAPI);
    }
  });
  function countryIpUpdate(countryAPI){
    const dialog = document.getElementById('dialogFirstVisit');
    const inputShipping = dialog.querySelector('input[name=shipping_code]');
    const countryRedirectCountry = document.querySelector(`#countryRedirectCountry`);
    const exists = Array.from(countryRedirectCountry.options).some(option => option.value === countryAPI);
    if(exists){
      countryRedirectCountry.value = countryAPI;
      inputShipping.value = countryAPI;
    }
  }

  const dialog = document.getElementById('dialogFirstVisit');
  if(dialog){
    const visitedKey = 'first_visit';
    const closeButton = dialog.querySelector('.closeButton');
    const inputShipping = dialog.querySelector('input[name=shipping_code]');
    const DialogLanguageForm = dialog.querySelector('#DialogLanguageForm');
    
    let hasVisited = localStorage.getItem(visitedKey);
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);

    const countryRedirectCountry = document.querySelector(`#countryRedirectCountry`);
  
    if(urlParams.get('fv')){
      hasVisited = true;
      localStorage.setItem(visitedKey, 'true');
      localStorage.setItem("shipping_country", urlParams.get('sc'));
    }

    if (!hasVisited) {
        dialog.showModal();
    }
    if(closeButton){
      closeButton.addEventListener("click", evt=>{
        const selectedOption = countryRedirectCountry.options[countryRedirectCountry.selectedIndex];
        const redirectURL = `https://${selectedOption.dataset.site}/?fv=true&sc=${countryRedirectCountry.value}`;
        localStorage.setItem(visitedKey, 'true');
        localStorage.setItem("shipping_country", countryRedirectCountry.value);
        //console.log(selectedOption.dataset.site)
        //console.log(window.location.hostname)
        if(window.location.hostname != selectedOption.dataset.site ){
          window.location.replace(redirectURL);
        }else{
          DialogLanguageForm.submit();
        }
        dialog.close();
      })
    }
    
    
    if(countryRedirectCountry){
      countryRedirectCountry.addEventListener("change", evt=>{
        inputShipping.value = countryRedirectCountry.value;
      });
    }
  }


  const detailsElements = document.querySelectorAll(`facet-filters-form.facets.small-hide .disclosure-has-popup.js-filter`);
  
  detailsElements.forEach((detail) => {
    
    const summary = detail.querySelector('summary');
    if (!summary) return; // si no hay summary, saltamos
    // Evita que el click abra o cierre el details
    summary.addEventListener('click', (e) => {
      e.preventDefault();
    });
    
    // Eventos para abrir/cerrar con hover solo en escritorio
    detail.addEventListener('mouseenter', () => {
      detail.setAttribute('open', '');
    });
    detail.addEventListener('mouseleave', () => {
      detail.removeAttribute('open');
    });
  });
  
});

$(document).on("click", ".menu-drawer_header_close", function () {
    $("body").toggleClass("overflow-hidden-tablet");
});
$(document).ready(function () {
    $(".testimonials .testimonial-container").slick({
        dots: true,
        infinite: true,
        speed: 300,
        slidesToShow: 3,
        slidesToScroll: 1,
        centerMode: true,
        centerPadding: "0px",
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    centerPadding: "0px",
                    slidesToShow: 1,
                },
            },
        ],
    });

    $(document).on("click", ".collec-size_guide", function (params) {
        $(".collec-size_modal").attr("open", "open");
    });
    $("a.wishlist-icon.header__icon--account").click(function (e) {
        e.preventDefault();
        const wishlistData = JSON.parse(localStorage.getItem("wishlist")) || [];
        // if (wishlistData.length === 0) {
        //   window.location.href="/pages/wishlist";
        // }
        const selected_option = wishlistData.map((item) => {
            return item.phandle;
        });
        window.location.href = "/pages/wishlist?&" + selected_option;
    });
});

// open header on hover starts
if ($(window).width() > 990) {
    $(".header__inline-menu ul li header-menu").hover(
        function () {
            $(this).children("details").attr("open", "true");
        },
        function () {
            $(this).children("details").removeAttr("open");
        }
    );
}

// open header on hover ends

$(document).on("click", ".sorting__filter label", function () {
    var srt_val = $(this).attr("data-val");
    $('.facet-filters__sort option[value="' + srt_val + '"]')
        .attr("selected", "selected")
        .siblings()
        .removeAttr("selected");
});
//............. this function work for custom sorting best seller and new .............
findSortedElement();
function findSortedElement() {
    var srt_val = $(".facet-filters__sort").find(":selected").attr("value");
    $('.sorting__filter input[data-input-val="' + srt_val + '"]').prop(
        "checked",
        true
    );
    $(
        '.mobile-facets__details.best-selling.mobile_sorting input[data-input-val="' +
            srt_val +
            '"]'
    ).prop("checked", true);
    $(
        '.mobile-facets__details.new.mobile_sorting input[data-input-val="' +
            srt_val +
            '"]'
    ).prop("checked", true);
}

//let locoScroll = null;
document.addEventListener("DOMContentLoaded", function () {
  const cardProducts = document.querySelectorAll(".card-wrapper");
  cardProducts.forEach(cardproduct=>{
    if(Boolean(cardproduct.querySelector('modal-opener'))) {
      cardproduct.addEventListener("click", evt=>{
        evt.preventDefault();
        let modalOpener = cardproduct.querySelector(".quick-add button");
        const clickEvent = new Event('click');
        modalOpener.dispatchEvent(clickEvent);
        console.log(modalOpener);
      });
    }
  });
    /*
    if (document.querySelector(".locomotive-scroll") === null) {
        return;
    }
    //set to every direct children of locomotive-scroll the data-scroll and data-scroll-section
    const scrollSections = document.querySelectorAll(".locomotive-scroll>*");
    scrollSections.forEach((section) => {
        section.setAttribute("data-scroll-section", "");
    });

    locoScroll = new LocomotiveScroll({
        el: document.querySelector(".locomotive-scroll"),
        smooth: true,
        smartphone: {
            smooth: false,
        },
        tablet: {
            smooth: false,
        },
        multiplier: 1.0,
    });
    console.debug("Locomotive Scroll Initialized", locoScroll);

    function locomotiveHeightBug() {
        window.dispatchEvent(new Event("resize"));
    }
    setTimeout(locomotiveHeightBug, 1000);
  */
});

/* Size gidde posicion */
document.addEventListener("DOMContentLoaded", function () {
  const announcementBar = document.querySelector(".header-wrapper .announcement-bar-section");
  if(announcementBar){
    document.querySelector(".header-wrapper").style.setProperty('--height-announcement', announcementBar.offsetHeight);
  }
  
  var miDiv = document.querySelector(".size_guideChart");
  var contenedor = document.querySelector(".product-form__header");

  if (miDiv && contenedor) {
    contenedor.appendChild(miDiv);
  }
});
function addToCartLink(item, event) {
  event.preventDefault();
  let boton_cart = document.querySelector('button[type="submit"].product-form__submit.button');
  if (boton_cart && !boton_cart.disabled) {
    item.setAttribute("disabled", "disabled");
    boton_cart.click();
    setTimeout(() => {
      item.removeAttribute("disabled");
    }, 800);
  }
}

//nuevo codigo carlos
class CustomRelatedDrawer extends HTMLElement {
  constructor() {
    super();
  }

  async connectedCallback() {
    const productId = this.getAttribute("product-id");
    const limit = this.getAttribute("limit") || 5;
    const currency = this.getAttribute("currency") || "USD";

    const endpoint = `/recommendations/products.json?product_id=${productId}&limit=${limit}`;

    const formatPrice = (cents) => {
      if (window.__shopifyMoneyFormat) {
        const format = window.__shopifyMoneyFormat;

        let value = cents / 100;

        let formattedValue;

        if (format.includes('{{amount_no_decimals}}')) {
          formattedValue = Math.round(value).toString();
          return format.replace('{{amount_no_decimals}}', formattedValue);
        }

        if (format.includes('{{amount}}')) {
          formattedValue = value.toFixed(2);
          return format.replace('{{amount}}', formattedValue);
        }

        return format;
      }

      // respaldo por si todo falla
      return new Intl.NumberFormat(undefined, {
        style: "currency",
        currency: currency,
        minimumFractionDigits: 0,
      }).format(cents / 100);
    };

    // Si tiene metafield → el HTML ya está dentro → NO hacemos nada
    if (this.classList.contains("have-meta")) {
      return;
    }

    // Caso contrario → hacemos FETCH como el componente antiguo
    try {
      const res = await fetch(endpoint);
      const data = await res.json();

      if (!data.products || data.products.length === 0) {
        this.innerHTML = "";
        return;
      }

      const productsHtml = data.products
        .filter((p) => !p.has_only_default_variant)
        .map((product) => {
          const variantsHtml = product.variants
            .map(
              (variant) => `
                <button 
                  type="button" 
                  class="variant-related ${variant.available ? "" : "disabled"}" 
                  data-variant="${variant.id}"
                  onclick="addRelatedVariantToCart(${variant.id}, this)"  
                >
                  ${variant.title}
                </button>
              `
            )
            .join("");

          return `
            <div class="card-recomendation-custom">
              <div class="wrapp">

                <div class="logo_card-recomendation">
                  <img 
                    src="${product.featured_image}" 
                    alt="${product.title}" 
                    loading="lazy"
                    width="100%"
                    height="auto"
                  >

                  <div class="button-related_custom">
                    <div class="wrapp-brc">
                      <input 
                        type="checkbox" 
                        id="related-cart_${product.id}" 
                        name="related_products"
                      />
                      <label for="related-cart_${product.id}">
                        <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none">
                          <g clip-path="url(#clip0_4130_7154)">
                            <rect width="19" height="19" fill="#1E1E1E"/>
                            <path d="M5 9H14V10H5V9Z" fill="white"/>
                            <path d="M9 14L9 5L10 5L10 14L9 14Z" fill="white"/>
                          </g>
                          <defs>
                            <clipPath id="clip0_4130_7154">
                              <rect width="19" height="19" fill="white"/>
                            </clipPath>
                          </defs>
                        </svg>
                      </label>

                      <div class="wrapp_variants">
                        <div class="wrapp_variants--box">
                          <p>Select Size</p>
                          <div class="wrapp_variants--values">
                            <div id="loaderspin" class="loaderspin">
                              <div></div>
                            </div>
                            ${variantsHtml}
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>

                <div class="content">
                  <a class="content-link-title" href="${product.url}">
                    ${product.title}
                  </a>
                  <p class="price rsb1">${formatPrice(product.price)}</p>
                </div>

              </div>
            </div>
          `;
        })
        .join("");

      this.innerHTML = `
        <div class="recommendations-grid">
          ${productsHtml}
        </div>
      `;
    } catch (error) {
      console.error("Error al cargar productos relacionados:", error);
    }
  }
}

customElements.define("custom-related-drawer", CustomRelatedDrawer);

function addRelatedVariantToCart(variantId, elem) {
  console.log(elem);
  const loaderele = elem.closest(".wrapp_variants--values");
  loaderele.querySelector('.loaderspin').style.display = 'flex';
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify({
      id: variantId,
      quantity: 1
    })
  })
  .then(res => {
    if (!res.ok) throw new Error("No se pudo agregar al carrito.");
    return res.json();
  })
  .then(data => {
    return fetch('/cart.js');
  })
  .then(res => res.json())
  .then(cartData => {
    publish(PUB_SUB_EVENTS.cartUpdate, {
      source: 'custom',
      cartData: cartData
    });
    loaderele.querySelector('.loaderspin').style.display = 'none';
  })
  .catch(err => {
    console.error("Error al agregar al carrito:", err);
  });
}

/* Size guide Script */
(function(){

  function activateSizeConverter() {

    const values = document.querySelectorAll(".size-value");
    const buttons = document.querySelectorAll(".unit-switch");
    const header = document.querySelector(".size-header");

    if (!values.length || !buttons.length) return;

    if (window.sizeConverterReady) return;
    window.sizeConverterReady = true;

    const original = [];

    values.forEach(cell => {
      original.push({
        element: cell,
        cm: parseFloat(cell.getAttribute("data-cm"))
      });
    });

    function convert(unit) {
      original.forEach(item => {
        if (unit === "cm") {
          item.element.innerText = item.cm;
        } else {
          item.element.innerText = (item.cm * 0.393701).toFixed(1);
        }
      });

      if (header) {
        header.innerText = unit === "cm" ? "SIZE CM" : "SIZE INCHES";
      }

      buttons.forEach(btn => {
        btn.classList.remove("active");
        if (btn.getAttribute("data-unit") === unit) {
          btn.classList.add("active");
        }
      });
    }


    buttons.forEach(btn => {
      btn.addEventListener("click", function(){
        convert(this.getAttribute("data-unit"));
      });
    });
    convert("in");
  }

  setTimeout(activateSizeConverter, 1000);
  document.addEventListener("DOMContentLoaded", activateSizeConverter);

})();

document.addEventListener("DOMContentLoaded", function () {
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (!entry.isIntersecting && entry.boundingClientRect.bottom < 0) {
        addtoCartBtnCont.classList.add("showStaticButton");
      }else{
        addtoCartBtnCont.classList.remove("showStaticButton");
      }
    });
  });
  const addtoCartBtnCont = document.querySelector('.pdp_buy');
  observer.observe(addtoCartBtnCont);

});